import React from 'react';
import { Tooltip } from '../Tooltip';
import { SectionHeader, Subtext } from './styled';

export function AggregateBySectionHeader({
  tooltipInfo,
}: {
  tooltipInfo?: string;
}) {
  return (
    <>
      <SectionHeader>
        Aggregate By
        {tooltipInfo && <Tooltip title={tooltipInfo} placement="right" />}
      </SectionHeader>
      <Subtext>
        All aggregations in this step will happen for the chosen time interval.
      </Subtext>
    </>
  );
}
